/**
 * Created by casteloyee on 2017/7/28.
 */
import React from 'react';
import {Modal, Row, Col, Input, Radio, Select, message, Tabs,Form} from 'antd';
import API_URL from '../../common/url';
import StringUtil from '../../common/StringUtil';
import AjaxRequest from '../../common/AjaxRequest';
import SiteSearchInput from "./SiteSearchInput";
import CustomerSearchInput from "./CustomerSearchInput";

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;

class EditCRAForm extends React.Component {

    state = {
        visible: false,
        confirmLoading: false,
        investigationSiteId: '',
        investigationSiteCode: '',
        user: {},
        selectedTab: "searchAdd",
    };


    hide = () => {
        this.props.changeEditCraVisible(false);
    };


    handleSubmit = () => {
            this.props.form.validateFields((err, values) => {
                if (err) {
                  return;
                }
                const {userId,mobile} = this.props.editCraInfo || {};
                const fieldValue = this.props.form.getFieldsValue() || {};
                const {userCompellation, userMobile, userTelphone, userEmail} = fieldValue;
                const { investigationSiteIdCustom } = this.state;
                this.setState({
                    confirmLoading:true,
                })
                const options = {
                    url: `${API_URL.customer.update}`,
                    data: {
                        userCompellation,
                        userEmail,
                        userMobile: mobile,
                        userTelphone,
                        userId
                    },
                    dataType: 'json',
                    doneResult: ( data => {
                        this.setState({
                            confirmLoading:false,
                        })
                        this.props.changeEditCraVisible(false);
                        message.success("修改成功");
                        this.props.reload();
                    }),
                    errorResult: data => {
                        this.setState({
                            confirmLoading:false,
                        })
                    }
                };
                AjaxRequest.sendRequest(options);
            });
    };
    
    render() {
        const { visible, confirmLoading, user } = this.state;
        const {email, investigationSiteCode,investigationSiteId,investigationSiteName,mobile,telephone,userName } = this.props.editCraInfo || {};
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        const formItemLayout = {
            labelCol: {
              span: 10
            },
            wrapperCol: {
              span: 13
            },
          };
        return (
            <Modal
                title="修改CRA"
                visible={this.props.visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal addCraModal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div>
                <Form>
                        <div>
                            <Row>
                                <Col span={10} style={{textAlign: "right",paddingRight:"13px"}}>中心名称(中心编号)：</Col>
                                <Col span={13} style={{whiteSpace:"normal",wordBreak:"break-all"}}>
                                    {`${investigationSiteName}(${investigationSiteCode})`}
                                </Col>
                            </Row>

                            <div className="field-max">
                                <FormItem label="姓名" {...formItemLayout}>
                                    {
                                        getFieldDecorator('userCompellation', {
                                            rules: [
                                                { required: true, message: '姓名不能为空' },
                                            ],
                                        })(<Input placeholder="请在此输入姓名" />)
                                    }
                                </FormItem>
                            </div>

                            <Row>
                                <Col span={10} style={{textAlign: "right",paddingRight:"13px"}}>手机号码：</Col>
                                <Col>{ mobile }</Col>
                            </Row>
                        </div>
                            <div className="field-max">
                                <FormItem label="固定电话" {...formItemLayout}>
                                    {
                                        getFieldDecorator('userTelphone',{
                                            rules:[
                                                { pattern:/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '必须是固定电话格式' },                                        
                                            ]
                                        })(<Input placeholder="请在此输入固话" />)
                                    }
                                </FormItem>
                            </div>
                            <div className="field-max">
                                <FormItem label="邮箱" {...formItemLayout}>
                                    {
                                        getFieldDecorator('userEmail',{
                                            rules:[
                                                { pattern:/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: '必须电子邮箱格式' },                                        
                                            ],
                                        }
                                        )(<Input placeholder="请在此输入电子邮箱" />)
                                    }
                                </FormItem>                        
                            </div>
                        </Form>
                </div>
                
            </Modal>
        )
    }
}

const EditCRA = Form.create({
    mapPropsToFields(props) {
        const {editCraInfo = {}} = props;
        return {
            userCompellation: {
                value: editCraInfo.userName,
            },
            userTelphone: {
                value: editCraInfo.telephone,
            },
            userEmail:{
                value: editCraInfo.email,
            },
        };
      },
})(EditCRAForm);

export default EditCRA;



// WEBPACK FOOTER //
// ./src/components/site/EditCRA.js